import { Divider, Typography } from "@mui/material";

export default function SectionTitle({title}) {
    return (<>
    <Typography fontWeight='bold' variant='subtitle1'>{title}</Typography>
    <Divider />
    </>)
    
}